module.exports = __webpack_public_path__ + "jpex.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpex.svg
// module id = 31
// module chunks = 0